module.exports = __webpack_public_path__ + "img/medical_branding.ef876207.webp";